/* eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch } from 'react-redux';
import MicrosoftLogin from "react-microsoft-login";
import { Image, Button } from "react-bootstrap";

import {
  AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID,
  AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URI
} from 'configs';
import { showMsalError, loginWithMsal } from 'actions';

const MsalLogin = () => {
  const dispatch = useDispatch();

  // Avoid nested Microsoft popups if this page ever loads inside an auth popup
  if (typeof window !== 'undefined' && window.opener) {
    return null;
  }

  const authHandler = (err, data) => {
    if (!err && data) {
      dispatch(loginWithMsal(data));
    }
    else if (err) {
      dispatch(showMsalError(err.name + ": " + err.errorMessage));
    }
    else {
      dispatch(showMsalError('Unable to login. Something went wrong'));
    }
  };

  return (
    <div className='microsoft-login-btn'>
      <MicrosoftLogin
        clientId={AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID}
        authCallback={(err, data) => { authHandler(err, data) }}
        redirectUri={AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URI}
        withUserData={true}
        buttonTheme="none"
      >
        <Button className="w-100 h-48 border-radius-99 mb-3 bg-transparent text-secondary border">
          <Image src="/assets/images/microsoft-icon.svg" className="microsoft-icon" /> Sign in with Microsoft
        </Button>
      </MicrosoftLogin>
    </div>
  );
};

export default React.memo(MsalLogin);
